import { connect} from 'react-redux';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { ApplicationState } from 'app/types-store';
import { mapPropsFromTranslations } from 'app/infrastructure/redux/container-factory';
import { translations } from './constants';
import { ShareCaseConfig, ShareCaseArgs } from './types';
import get from 'lodash/get';

export const withSharing = (config:ShareCaseConfig) => (component: any, uiEngineProps: ConnectedComponentProps) => {
  const path = uiEngineProps.hostProps().statePath;
  let textPath = path;

  if (Array.isArray(path)) {
    // For case listings the texts are on the top level, not within the instance.
    textPath = path[0];
  }

  const mapStateToProps = (state:ApplicationState) => ({
    translate: mapPropsFromTranslations(translations, get(state, textPath)?.texts),
    url: uiEngineProps.url,
    userEmail: state.app.userInfo.email
  });

  const mapDispatchToProps = () => ({    
    getUsers: config.getUsers,
    shareDocument: async (args: ShareCaseArgs, translate) => config.shareDocument(uiEngineProps, args, translate)
  });

  return connect(mapStateToProps, mapDispatchToProps)(component);
};
